import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormControl, FormLabel } from '@material-ui/core';
import styled from 'styled-components';

interface Props {
  onChange: (checked: boolean) => void;
  value: boolean
}

const Wrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

const SelectToBeApprovedOnly: React.FunctionComponent<Props> = (props) => {

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(event.target.checked);
  };

  return (
    <Wrapper>
      <FormControl component="fieldset">
        <FormLabel component="legend">To be approved only</FormLabel>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.value}
              onChange={onChange}
              value={props.value}
            />
          }
          label='To be approved only'
        />
      </FormControl>
    </Wrapper>
  );
};

export default SelectToBeApprovedOnly;
